import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_CONFIG } from '../config/auth-config';
import { IAuthService } from '../services/iauth.service';

/**
 * Guard que previne acesso à tela de login quando já autenticado
 * Redireciona para dashboard se já houver um token válido
 */
export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(IAuthService);
  const router = inject(Router);
  const config = inject(AUTH_CONFIG);

  if (!authService.isAccessTokenInvalido()) {
    const redirectUrl = config.routes?.redirectAfterLogin || '/dashboard';
    router.navigate([redirectUrl]);
    return false;
  }

  return true;
};
